import axios from "./axiosinstance";

const PermissionApi = {
  getByRole: (roleId) => axios.get(`permissions/by-role?roleId=${roleId}`),
  bulkSet: (payload) => axios.post("permissions/bulk-set", payload),
  reset: (payload) => axios.post("permissions/reset", payload),
};

export default PermissionApi;



